import { isDefined } from "@clipboard-health/util-ts";
import { truncate } from "lodash";
import pluralize from "pluralize";

export const APPLICABLE_WORKPLACES_TEXT_TRUNCATION_LENGTH = 26;

// ALL means Global
// PLACE means State / MSA / County (aka region). Place is needed to display the name of the place.
// WORKPLACE means workplace. Count is needed to display the number of workplaces.
export interface ApplicableWorkplacesDetails {
  type: "ALL" | "PLACE" | "WORKPLACE";
  place?: string;
  count?: number;
}

export function getApplicableWorkplacesTextForRequirement(
  applicableWorkplacesDetails: ApplicableWorkplacesDetails,
  shouldTruncate = true
) {
  const { type, place, count } = applicableWorkplacesDetails;

  let applicableWorkplacesText: string | undefined;

  if (type === "ALL") {
    applicableWorkplacesText = "Clipboard";
  } else if (type === "PLACE" && isDefined(place)) {
    applicableWorkplacesText = `All workplaces in ${place}`;
  } else if (type === "WORKPLACE" && isDefined(count)) {
    applicableWorkplacesText = `${count} ${pluralize("workplace", count)}`;
  } else {
    applicableWorkplacesText = undefined;
  }

  return isDefined(applicableWorkplacesText) && shouldTruncate
    ? truncate(applicableWorkplacesText, { length: APPLICABLE_WORKPLACES_TEXT_TRUNCATION_LENGTH })
    : applicableWorkplacesText;
}
